import instance from '../util/axios';

export const getSubscriptionPlans = async () => {
  const URL = `subscription/plans`;
  const response = await instance.get(URL);
  return response;
};

export const createCheckoutSession = async (plan_id) => {
  const URL = `subscription/checkout`;
  const response = await instance.post(URL, { plan_id });
  return response;
};

export const getCurrentSubscription = async () => {
  const URL = `subscription/current`;
  const response = await instance.get(URL);
  return response;
};

export const getInvoices = async () => {
  const URL = `subscription/invoices`;
  const response = await instance.get(URL);
  return response;
};

export const createCustomerPortal = async () => {
  const URL = `subscription/customer-portal`;
  const response = await instance.post(URL);
  return response;
};

export const changePlan = async (plan_id, data = {}) => {
  const URL = `subscription/change-plan`;
  const response = await instance.post(URL, { plan_id, ...data });
  return response;
};

export const cancelSubscription = async () => {
  const URL = `subscription/cancel`;
  const response = await instance.post(URL);
  return response;
};

export const reactivateSubscription = async () => {
  const URL = `subscription/reactivate`;
  const response = await instance.post(URL);
  return response;
};

export const downgradeSubscription = async (data) => {
  const URL = `subscription/downgrade`;
  const response = await instance.post(URL, data);
  return response;
};

export const cancelDowngradeSubscription = async () => {
  const URL = `subscription/cancel-downgrade`;
  const response = await instance.post(URL);
  return response;
};

export const previewChangePlan = async (plan_id, data = {}) => {
  const URL = `subscription/change-plan-preview`;
  const response = await instance.post(URL, { plan_id, ...data });
  return response;
};

